import React from 'react';
import './PromotionBenefits.css';
import {RewardSelector} from './PromotionBenefits';

export function RewardBadge({total}) {
    return <span className="nw-reward-badge">{Number(total) === 0 ? 'Free gift' : 'Offer price'}</span>;
}

export default function RewardProduct({item,busy=false}) {
    const quantity = Number(item.quantity) || 1;
    const total = Number(item.payable_total ?? item.line_total ?? 0);
    const unit = total / quantity;
    const original = Number(item.unit_price ?? Number(item.mrp_subtotal || 0) / quantity);
    const money = value => `₹${Number(value).toFixed(2)}`;
    return <article className="ps-cart-item nw-reward-product" aria-label={`Promotional reward: ${item.name}`} aria-busy={busy}>
        <div className="ps-cart-item__product">
            <div className="ps-cart-item__image"><figure><img src={item.display_image || '/assets/img/logo-no-image.png'} alt={item.name} loading="lazy" onError={event => {
                if (!event.currentTarget.dataset.fallback) {event.currentTarget.dataset.fallback='true'; event.currentTarget.src='/assets/img/logo-no-image.png';}
            }}/></figure></div>
            <div className="ps-cart-item__content"><span className="ps-cart-item__title">{item.name}</span><RewardBadge total={total}/><small>Included with your offer</small></div>
        </div>
        <div className="ps-cart-item__cell ps-cart-item__priceBlock"><span className="ps-cart-item__label">Price</span><strong className="ps-cart-item__price">{money(unit)}</strong>{original > unit && <del className="ps-cart-item__strike">{money(original)}</del>}</div>
        <div className="ps-cart-item__cell ps-cart-item__qtyBlock"><span className="ps-cart-item__label">Quantity</span><strong>{quantity}</strong><small>Set by offer</small></div>
        <div className="ps-cart-item__cell ps-cart-item__totalBlock"><span className="ps-cart-item__label">Total</span><strong className="ps-cart-item__total">{money(total)}{total === 0 && ' · Free'}</strong></div>
    </article>;
}

export function RewardOffers({quote,onSelect,busy=false,embedded=false}) {
    const groups = new Map();
    (quote?.reward_choices || []).forEach(choice => groups.set(String(choice.promotion_id), {choice,items:[]}));
    (quote?.reward_items || []).forEach(item => {
        const id = String(item.reward_promotion_id);
        if (!groups.has(id)) groups.set(id, {items:[]});
        groups.get(id).items.push(item);
    });
    return <>{Array.from(groups, ([id,group]) => {
        const promotion = quote?.applied_promotions?.find(promotion => String(promotion.promotion_id) === id);
        const name = group.choice?.name || promotion?.promotion_name || group.items[0]?.applied_promotions?.find(promotion => String(promotion.promotion_id) === id)?.promotion_name || 'Product offer';
        return <section className={`nw-reward-offer-card${embedded ? ' nw-reward-offer-card--embedded' : ''}`} aria-label={`Offer: ${name}`} aria-busy={busy} key={id}>
            <div className="nw-reward-offer-card__header">{!embedded && <span>Offer</span>}<h3>{name}</h3>
                {group.choice && <RewardSelector choice={group.choice} label="Choose your reward" onSelect={onSelect} busy={busy}/>}
                {group.choice && group.items.length > 0 && onSelect && <button type="button" className="nw-reward-remove" disabled={busy} aria-label={`Remove add-on for ${name}`} onClick={()=>onSelect(group.choice.promotion_id,0)}>Remove add-on</button>}
            </div>
            {group.items.map((item,index) => <RewardProduct key={`${item.product_sku_id}-${index}`} item={item} busy={busy}/>)}
            {!group.items.length && <p className="nw-reward-offer-card__empty">{group.choice?.declined ? 'Add-on removed. You can choose another product above anytime.' : 'Select an available product above. Your reward will appear here.'}</p>}
        </section>;
    })}</>;
}
